// extracted by mini-css-extract-plugin
export default {"container":"PiiJmvEy6PQ4Io7gdiQg__container___","footer":"aEoZ7m0vWna3I23xvBZY__footer___"};